module.exports = __webpack_public_path__ + "static/media/EandG-Financial-Statement.5e63d235.pdf";